import { atom } from 'jotai';
import type { MapRef } from 'react-map-gl';
import searchAtomPair, { type SearchParams } from 'atoms/search-atom';
import type {
  EvaluationCaseResult,
  EvaluationCaseFacets,
  EvaluationCaseAggregations,
} from './types';

export interface EvaluationCaseParams extends SearchParams {
  evaluationType?: string[];
  createdBy?: string[];
  createdAt?: { start?: string; end?: string };
  updatedAt?: { start?: string; end?: string };
}

/**
 * Creates a Jotai search atom pair for the Evaluation Cases list page.
 * @return {{ searchAtom: Atom }} Atom that fetches from POST /queries/evaluation_cases
 */
export const createEvaluationCaseSearchAtom = () =>
  searchAtomPair<
    EvaluationCaseResult,
    EvaluationCaseParams,
    EvaluationCaseFacets,
    EvaluationCaseAggregations
  >({ href: '/queries/evaluation_cases' });

/** The Cases list map strip's map handle, so the strip can fit the map to its features. */
export const evaluationCasesMapRefAtom = atom<MapRef | null>(null);
